import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import updateAddress from './updateAddress';
import verifiedAddress from './verifiedAddress';
import resetAvailabilityModal from './resetAvailabilityModal';
import updateEligibility from './updateEligibility';
import updateProductMap from './updateProductMap';
import windowCategoryMappings from './windowCategoryMappings';
import mountTypes from './mountTypes';
import specMappings from './specMappings';

const actions = {
  [types.availability.UPDATE_ADDRESS]: updateAddress,
  [types.availability.VERIFIED_ADDRESS]: verifiedAddress,
  [types.availability.RESET_MODAL]: resetAvailabilityModal,
  [types.availability.UPDATE_ELIGIBILITY]: updateEligibility,
  [types.availability.UPDATE_PRODUCT_MAP]: updateProductMap,
  [types.availability.WINDOW_CATEGORY_MAPPINGS]: windowCategoryMappings,
  [types.availability.MOUNT_TYPES]: mountTypes,
  [types.availability.SPEC_MAPPINGS]: specMappings,
  '@@INIT': resetAvailabilityModal,
};

const defaultState = {
  address: {},
  validationResult: {},
  eligibilityList: [],
  productMap: {},
  allProductsEligible: false,
  windowCategoryMappings: { 0: {} },
  mountTypes: [],
};

export default (state = defaultState, action) => (actions[action.type] || identity)(state, action);
